import React, { useState, useEffect } from 'react';
import { Typography, Card, Form, Input, Button, message, Spin, Alert, Divider } from 'antd';
import { SaveOutlined, AlipayCircleOutlined } from '@ant-design/icons';
import settingsService from '../services/settings';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const Settings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [hasConfig, setHasConfig] = useState(false);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const settings = await settingsService.getSettings();
      form.setFieldsValue({
        alipayAppId: settings.alipayAppId,
        alipayPrivateKey: settings.alipayPrivateKey,
        alipayPublicKey: settings.alipayPublicKey
      });
      setHasConfig(settings.hasAlipayConfig);
    } catch (error) {
      message.error('获取设置失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSave = async (values) => {
    setSaving(true);
    try {
      await settingsService.saveSettings(values);
      message.success('保存成功');
      fetchSettings();
    } catch (error) {
      message.error('保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Title level={3}>系统设置</Title>

      <Card 
        title={
          <span>
            <AlipayCircleOutlined style={{ color: '#1677ff', marginRight: 8 }} />
            支付宝配置
          </span>
        }
        extra={hasConfig ? <Text type="success">已配置</Text> : <Text type="secondary">未配置</Text>}
      >
        <Alert
          message="配置说明"
          description={
            <div>
              <Paragraph style={{ marginBottom: 8 }}>
                配置支付宝开放平台的应用密钥后，可以自动同步支付宝账单。
              </Paragraph>
              <Paragraph style={{ marginBottom: 0 }}>
                1. 登录 <a href="https://open.alipay.com" target="_blank" rel="noopener noreferrer">支付宝开放平台</a> 创建应用<br />
                2. 在应用中添加「获取会员信息」能力<br />
                3. 生成密钥并填写到下方
              </Paragraph>
            </div>
          }
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
        >
          <Form.Item
            label="应用ID (AppID)"
            name="alipayAppId"
            rules={[{ required: true, message: '请输入应用ID' }]}
          >
            <Input placeholder="例如：2021004174626051" />
          </Form.Item>

          <Form.Item
            label="应用私钥"
            name="alipayPrivateKey"
            rules={[{ required: true, message: '请输入应用私钥' }]}
            extra="在支付宝开放平台生成的RSA2私钥，不要包含头尾标识"
          >
            <TextArea 
              rows={4} 
              placeholder="MIIEvgIBADANBgkqhkiG9w0BAQEFAASC..."
            />
          </Form.Item>

          <Form.Item
            label="支付宝公钥"
            name="alipayPublicKey"
            rules={[{ required: true, message: '请输入支付宝公钥' }]}
            extra="在支付宝开放平台获取的支付宝公钥，不要包含头尾标识"
          >
            <TextArea 
              rows={4} 
              placeholder="MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8A..."
            />
          </Form.Item>

          <Divider />

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              icon={<SaveOutlined />}
              loading={saving}
            >
              保存配置
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
};

export default Settings;
